import * as React from 'react';
import TextStyle from '@able/react/dist/TextStyle';
import {
    IProductOrder,
    ITrackerValueType,
    ProgressTrackerStatusType
} from '@applications/order-tracker/config/order-tracker-new-common/types';
import {
    CeaseAndCancel,
    ActivityState,
    ProgressTrackerStatus,
    ProgressTrackerStages,
    ActivityType, DefaultContent, ProgressTrackerStagesLookUp, ActivityStateLookup
} from '@applications/order-tracker/config/order-tracker-new-common/constants';
import {
    IProgressTrackerGettingThingsReady, ProgressTrackerActivatingServiceInProgressComponent,
    ProgressTrackerGettingThingsReady
// tslint:disable-next-line:max-line-length
} from '@applications/order-tracker/pages/product-sheet/components/progress-tracker-tab/components/progress-tracker-getting-things-ready';

const getMessage = (message: string) => {
    return (
        <TextStyle alias="TextBodyShort">
            <p>{message}</p>
        </TextStyle>
    )
}

const getStatus = (state: string): ProgressTrackerStatusType => ({
    [ActivityState.Completed]: ProgressTrackerStatus.Completed,
    [ActivityState.InProgress]: ProgressTrackerStatus.InProgress,
    [ActivityState.NotStarted]: ProgressTrackerStatus.NotStarted,
})[state] as ProgressTrackerStatusType;

const getContentMap = () => ({
    [`${ActivityState.Completed}.${ProgressTrackerStages.OrderSubmitted}`]: getMessage(
        CeaseAndCancel.OrderSubmitted.Completed
    ),
    [`${ActivityState.Completed}.${ProgressTrackerStages.GettingThingsReady}`]: getMessage(
        CeaseAndCancel.GettingThingsReady.Completed
    ),
    [`${ActivityState.Completed}.${ProgressTrackerStages.Completed}`]: getMessage(
        CeaseAndCancel.Completed.Completed
    ),
    [`${ActivityState.InProgress}.${ProgressTrackerStages.OrderSubmitted}`]: getMessage(
        CeaseAndCancel.OrderSubmitted.InProgress
    ),
    [`${ActivityState.InProgress}.${ProgressTrackerStages.GettingThingsReady}`]: getMessage(
        CeaseAndCancel.GettingThingsReady.InProgress
    ),
    [`${ActivityState.InProgress}.${ProgressTrackerStages.Completed}`]: getMessage(
        CeaseAndCancel.Completed.InProgress
    ),
    [`${ActivityState.NotStarted}.${ProgressTrackerStages.OrderSubmitted}`]: getMessage(
        CeaseAndCancel.OrderSubmitted.NotStarted
    ),
    [`${ActivityState.NotStarted}.${ProgressTrackerStages.GettingThingsReady}`]: getMessage(
        CeaseAndCancel.GettingThingsReady.NotStarted
    ),
    [`${ActivityState.NotStarted}.${ProgressTrackerStages.Completed}`]: getMessage(
        CeaseAndCancel.Completed.NotStarted
    ),
});

const getContentForCeaseAndCancel = (progressStage: string, state: string) => {
    const contentMap = getContentMap();
    return contentMap[`${state}.${progressStage}`] || null;
};

const getContent = (progressStage: string, state: string, product: IProductOrder) => {
    if (ProgressTrackerStagesLookUp[progressStage] && ActivityStateLookup[state]) {
        const progress = ProgressTrackerStagesLookUp[progressStage];
        const activityState = ActivityStateLookup[state];
        const temp: IProgressTrackerGettingThingsReady = {
            message: DefaultContent[progress][activityState],
            appendInstallationDetails: product.equipmentDetails.consignmentNumber !== '',
            progressStage,
            state
        };
        if (progressStage === ProgressTrackerStages.GettingThingsReady) {
            return (
                <ProgressTrackerGettingThingsReady message={temp.message}
                                                   appendInstallationDetails={temp.appendInstallationDetails}
                                                   progressStage={progressStage} state={state}/>
            );
        } else if (progressStage === ProgressTrackerStages.ActivatingService && temp.appendInstallationDetails === true &&
            (state === ActivityState.NotStarted || state === ActivityState.InProgress)) {
            return (
                <ProgressTrackerActivatingServiceInProgressComponent message={temp.message}
                                                                     appendInstallationDetails={temp.appendInstallationDetails}
                                                                     progressStage={progressStage} state={state}/>
            )
        } else {
            return getMessage(DefaultContent[progress][activityState]);
        }
    } else {
        return null;
    }
}

export const updatedActivityList = (product: IProductOrder) => {
    const updatedActivityListWithContent: ITrackerValueType[] = product.progressTrackerActivities.map((ele) => ({
        title: ele.progressStage,
        description: ele.state,
        status: getStatus(ele.state),
        content: (product?.activityType?.toLowerCase() === ActivityType.Cease || product?.activityType?.toLowerCase() === ActivityType.Cancel) ?
        getContentForCeaseAndCancel(ele.progressStage, ele.state) : getContent(ele.progressStage, ele.state, product)
    }));
    return updatedActivityListWithContent
}
